<template>

    <card-list-item @click="">
        <template v-slot:icon><i class="far fa-terminal fa-fw"></i></template>
        <template v-slot:content>
            <div class="columns">
                <div class="column">
                    <div class="tile-title">{{activity.data.message}}</div>
                    <div class="meta"><b-tag size="is-small" :type="getLevelColor(activity.data.level)" class="mr-2">{{activity.data.level | uppercase}}</b-tag>{{activity.data.endpoint}}</div>
                </div>
            </div>

<!--            <json-viewer :value="activity" :expand-level="1"></json-viewer>-->
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">{{activity.date | moment('h:mm a')}}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <!--                            <toolbar class="toolbar">-->
                <!--                                <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>-->
                <!--                            </toolbar>-->

                <div class=" mt-1">
                    <div class="meta mt-3">

                    </div>

                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "../../TIER/components/CardListItem";
    export default {
        name: "ActivityLogger",
        components: {CardListItem},
        props: ['activity'],
        data() {
            return {
                titles
            };
        },
        methods: {
            getLevelColor: function() {
                if (this.activity.data.level === 'info') {
                    return 'is-success';
                } else if (this.activity.data.level === 'warn') {
                    return 'is-warning';
                } else if (this.activity.data.level === 'error') {
                    return 'is-danger';
                }
            }
        }
    };

    let titles = {
        '/app/registrations/': 'Conference Registrations',
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
